import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTheme } from '@mui/material/styles';

function CodeList({ codes }) {
    const theme = useTheme();
  
    const commonCellStyles = {
      padding: '16px',
      height: '60px',
      verticalAlign: 'middle'
    };
    const PLAN_NAMES = {
        monthly_plan: 'Monthly',
        annual_plan: 'Annual',
        all_plans: 'All Plans'
      };
    const headerCellStyles = {
      ...commonCellStyles,
      backgroundColor: theme.palette.background.default || '#bac7db',
      fontWeight: 'bold',
      fontSize: '0.875rem',
      borderBottom: '2px solid',
      borderColor: 'grey.300'
    };
  
    return (
      <Card sx={{ 
        boxShadow: 'none', 
        border: '1px solid', 
        borderColor: 'grey.200',
        backgroundColor: 'white'
      }}>
        <MDBox p={3}>
          <MDTypography variant="h6" mb={3}>Your Discount Codes</MDTypography>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Code</MDTypography>
                </th>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Type</MDTypography>
                </th>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Value</MDTypography>
                </th>
                <th style={headerCellStyles}>
                <MDTypography variant="h6" component="span">Plans</MDTypography>
                </th>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Uses</MDTypography>
                </th>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Valid Until</MDTypography>
                </th>
                <th style={headerCellStyles}>
                  <MDTypography variant="h6" component="span">Status</MDTypography>
                </th>
              </tr>
            </thead>
            <tbody>
              {codes.map((code) => (
                <tr key={code.id} style={{ '&:hover': { backgroundColor: 'grey.50' } }}>
                  <td style={commonCellStyles}>
                    <MDTypography variant="button" fontWeight="medium">
                      {code.code}
                    </MDTypography>
                  </td>
                  <td style={commonCellStyles}>
                    <MDTypography variant="button" color="text">
                      {code.type === 'percentage' ? 'Percentage' : 'Fixed'}
                    </MDTypography>
                  </td>
                  <td style={commonCellStyles}>
                    <MDTypography variant="button" fontWeight="medium" color="info">
                      {code.type === 'percentage' ? `${code.value}%` : `$${code.value}`}
                    </MDTypography>
                  </td>
                  <td style={commonCellStyles}>
                  <MDTypography variant="button" color="text">
                    {Array.isArray(code.plans) 
                      ? code.plans.map(plan => PLAN_NAMES[plan]).join(', ')
                      : 'No plans set'}
                  </MDTypography>
                </td>
                  <td style={commonCellStyles}>
                    <MDTypography variant="button" color="text">
                      {code.currentUses || 0}/{code.maxUses}
                    </MDTypography>
                  </td>
                  <td style={commonCellStyles}>
                    <MDTypography variant="button" color="text">
                      {new Date(code.validUntil.seconds * 1000).toLocaleDateString()}
                    </MDTypography>
                  </td>
                  <td style={commonCellStyles}>
                    <MDTypography 
                      variant="button" 
                      color={code.active ? "success" : "error"}
                    >
                      {code.active ? 'Active' : 'Inactive'}
                    </MDTypography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </MDBox>
      </Card>
    );
  }
  
  export default CodeList;